import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=433f1ee0&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f1ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433f1ee0')) {
      api.createRecord('433f1ee0', component.options)
    } else {
      api.reload('433f1ee0', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=433f1ee0&scoped=true", function () {
      api.rerender('433f1ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/IndexPage.vue"
export default component.exports